(ns frontend.view.nev.kyc.process-status-views.esign-in-progress
  (:require
   [common.languages :as languages]
   [common.localization :as loc]
   [common.schema.entities.workspace.kyc.templates.template-registry :as template-registry]
   [frontend.actions.kyc-process :as kyc-process-actions]
   [frontend.logging :as logging]
   [frontend.utils :as fu]
   [frontend.view.entity-viewers.modules.entity-esign.signatory.view :as signatory]
   [frontend.view.nev.kyc.process-status-views.event :as event]
   [frontend.view.nev.kyc.process-status-views.sub :as sub]
   [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]
   [re-frame.core :as rf]))

(defn submit-for-review!
  [entity state-atom]
  (kyc-process-actions/*->submit-for-review!
   {:kyc-process-id (:db/id entity)}
   (fn [_resp]
     (swap! state-atom assoc :submitted-for-review true)
     (fu/timeout 3000
                 #(swap! state-atom dissoc :submitted-for-review)))
   (fn [resp]
     (logging/error "Failed to submit KYC for review " resp))))

(defn complete!
  [entity answers-atom save!]
  (kyc-process-actions/*->complete!
   {:kyc-process-id (:db/id entity)}
   (fn [_resp]
     (swap! answers-atom dissoc :kyc-legal-entity/signature-date)
     (deref answers-atom)
     (save!))
   (fn [resp]
     (logging/error "Failed to complete KYC " resp))))

(defn view
  [_state-atom local-atom entity esign-process signatories _save!]
  (let [template-schema (template-registry/templates (:kyc-process/template entity))]
    (fn [state-atom local-atom entity esign-process signatories save!]
      (let [lang (or (:lang @state-atom)
                     (:kyc-process/language entity))
            lang-kw (or (languages/long->short lang)
                        lang)
            reminding-signatory-ids @(rf/subscribe [::sub/reminding-signatory-ids])
            esign-v2-process? (:esign-process/esign-v2? esign-process)]
        [:div.d-flex.flex-column.flex-1-hidden
         [:div.d-flex.flex-column.flex-1-hidden.scroll-y
          [:div.container.pt-4
           [:div.card--kyc.card--kyc--min-height
            [:div.p-5
             [:p.mb-4 (loc/tr :waiting-for-signatories)]
             (->> signatories
                  (map
                   (fn [{:keys [db/id signatory/email signatory/signed? signatory/last-reminded-on] :as s}]
                     ^{:key (str "esign-signatory-" id)}
                     [signatory/view
                      {:signatory-name   (:signatory/name s)
                       :email            email
                       :signed?          signed?
                       :last-reminded-on last-reminded-on
                       :processing?      (contains? reminding-signatory-ids id)
                       :on-remind        (fn []
                                           (let [event-kw (if esign-v2-process?
                                                            ::event/v2-send-reminder-comment
                                                            ::event/send-reminder-comment)]
                                             (rf/dispatch [event-kw (:db/id esign-process) email id])))}])))]]]]
         [:div.d-flex.flex-static.kyc-submit-footer
          [:div.container
           [:div.d-flex.justify-content-between
            [kvu/exit-button entity lang-kw]
            (when-let [help-email (:kyc-template/help-email-address template-schema)]
              [:div.d-flex.flex-column
               [:span (loc/tr :kyc-wip-need-help? nil lang-kw)]
               [:a
                {:href (str "mailto:" help-email)}
                help-email]])]]]]))))
